<div class="search-container" appClickOutside (clickOutside)="closeDropdown()">
    <div class="search_dropdown-btn d-flex align-items-center gap-2 bg-white">
        <input
            type="search"
            class="px-2 py-3 search_input"
            id="search-input"
            [placeholder]="searchTextPlaceholder || 'Search'"
            [title]="searchTextPlaceholder || 'Search'"
            autocomplete="off"
            spellcheck="false"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
            (keyup.enter)="onEnterPressed()" 
        />
        <span (click)="onEnterPressed()" class="cursor-pointer" title="Search">
            <img src="../../../../../assets/media/svg/search-icon.svg" alt="Search Icon" class="search_search-icon">
        </span>

        <div class="search_filter_container" *ngIf="formGroup && formFields">
            <span 
                class="search_filter-icon cursor-pointer" 
                title="Advanced Search" 
                (click)="toggleDropdown()"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                    <path d="M2 4.6665H14" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M4 8H12" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M6.66667 11.3335H9.33334" stroke="#000000" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </span>
        </div>
    </div>
    
    <div class="search_dropdown-content p-4" *ngIf="isDropdown">
        <form [formGroup]="formGroup" *ngIf="formGroup && formFields">
            <div class="row">
                <ng-container *ngFor="let field of formFields; trackBy: trackByFieldName">
                    <div class="form-group mb-3 col-12 d-flex align-items-end gap-2">
                        <label 
                            [for]="field.name" 
                            class="form-label m-0" 
                            [class.required]="field.required"
                        >{{ field.label + ':' }}</label>
                        <ng-container [ngSwitch]="field.formType">
                            <input 
                                *ngSwitchCase="'input'"
                                pInputText
                                [type]="field.inputType"
                                [name]="field.name"
                                [formControlName]="field.name"
                                [class]="{
                                    'form-control': true,
                                    'filter-form-control': true,
                                    'ng-dirty': formGroup.controls[field.name].invalid && formGroup.controls[field.name].touched
                                }"
                            >

                            <p-dropdown
                                *ngSwitchCase="'select'"
                                [options]="field.options ?? []"
                                [filter]="(field.options?.length || 0) > 10"
                                optionLabel="label"
                                optionValue="value"
                                [formControlName]="field.name"
                                [placeholder]="'Select ' + field.label"
                                styleClass="form-control filter-form-control" 
                                [class]="{ 
                                    'ng-dirty': formGroup.get(field.name)?.invalid && formGroup.get(field.name)?.touched 
                                }"
                                (onChange)="handleSelectChange($event, field.name)"
                            ></p-dropdown>
                        </ng-container>
                    </div>
                    <!-- Validation error message -->
                    <span 
                        class="form-error-message" 
                        *ngIf="formGroup.controls[field.name].invalid && formGroup.controls[field.name].touched"
                    >
                        {{ getErrorMessage(field.name, field.label) }}
                    </span>
                </ng-container>
            </div>
    
            <div class="form_btns d-flex align-items-center justify-content-center flex-wrap gap-3 mt-4">
                <button class="anq-btn anq-btn-secondary-outline fs-5" (click)="clearForm()">Clear</button>
                <button 
                    class="anq-btn anq-btn-secondary fs-5" 
                    [disabled]="formGroup.invalid"
                    (click)="filterTable()"
                >
                    Search
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.66536 14.0011C11.1632 14.0011 13.9987 11.1656 13.9987 7.66781C13.9987 4.17 11.1632 1.33447 7.66536 1.33447C4.16756 1.33447 1.33203 4.17 1.33203 7.66781C1.33203 11.1656 4.16756 14.0011 7.66536 14.0011Z" stroke="#ffffff" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.6654 14.6678L13.332 13.3345" stroke="#ffffff" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </form>
    </div>
</div>